module.exports = __webpack_public_path__ + "static/img/function-box-img5.3bdc3ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unifiedProcess/function-box-img5.png
// module id = rmii
// module chunks = 0